module.exports = __webpack_public_path__ + "img/icon-arrow right.44ec4182.svg";